/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import {
  matchRoutes,
  Route,
  Routes,
  useLocation,
  useNavigate,
  Navigate,
  useSearchParams,
} from 'react-router-dom';
import { Box } from '@tonic-one/react';
import PageNotFound from './components/Common/PageNotFound';
import PrivateRoute from './components/Common/PrivateRouter';
import { usePermissionStore } from './models/usePermissionModel';
import routerConfig, { Router } from './routerConfig';
import common, { changeBreadCrumbs, isInUIC } from './utils/common';
import { useBreadCrumbStore } from '@Models/useBreadCrumbModel';
import getBreadCrumb from '@Components/CasHeader/BreadCrumb/getBreadCrumb';
import { useTranslation } from 'react-i18next';
import ServiceException from '@Components/Common/ServiceException';
import NoPermission from '@Components/Common/NoPermission';
import { useOrgStore } from '@Models/useOrgModel';
function getDefaultRouter(routes: Router[], permissions: any) {
  if (permissions) {
    for (const router of routes) {
      if (!router.permission) {
        return router;
      }
      const withReadPermission = common.withReadPermission(
        router.permission,
        permissions
      );
      if (withReadPermission) {
        return router;
      }
    }
  }
}
/**
 * refer to https://ui.dev/react-router-v5-route-config/
 */
const CasRouter = () => {
  const routes = common.flattenRoutes(routerConfig);
  const location = useLocation();
  const permissionModel = usePermissionStore();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { orgs } = useOrgStore();
  const breadCrumbModal = useBreadCrumbStore();
  useEffect(() => {
    const matches = matchRoutes(common.flattenRoutes(routerConfig), location);
    try {
      if (
        location.pathname.indexOf('/403') < 0 &&
        orgs !== null &&
        orgs.filter((item) => item.key !== 'all').length === 0
      ) {
        const url = `/403`;
        navigate(url);
        if (isInUIC()) {
          changeBreadCrumbs([
            {
              breadCrumb: t('common.nativeApp.productName'),
              router: '',
            },
          ]);
        }
      }
      const breadCrumbs = getBreadCrumb(t, matches);
      breadCrumbModal.updateBreadCrumb(breadCrumbs);
    } catch (error) {
      console.log(error);
    }
  }, [location, orgs]);
  useEffect(() => {
    /**
     * this is a trick,the user first coming,if the pathLoad is '/',
     * we should task user redirect to the first page that he can visit
     */
    if (permissionModel.permissions && location.pathname === '/') {
      const firstRouter = getDefaultRouter(
        routerConfig,
        permissionModel.permissions
      );
      // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
      navigate(firstRouter!.path, { replace: true });
    }
  }, [permissionModel.permissions]);
  /**
   * background: '#151515'
   */
  function RedirectToLogs() {
    const [searchParams] = useSearchParams();

    return <Navigate to={`/logs?${searchParams.toString()}`} replace />;
  }

  function RedirectToAdministration() {
    const location = useLocation();
    const newPathname = location.pathname.replace(
      '/administrator',
      '/administration'
    );

    return <Navigate to={newPathname + location.search} replace />;
  }
  return (
    <Box minHeight="inherit">
      <Routes>
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <PrivateRoute readPermissionName={route.permission}>
                <route.element />
              </PrivateRoute>
            }
          />
        ))}
        <Route path="/403" element={<NoPermission />} />
        <Route path="/log" element={<RedirectToLogs />} />
        <Route path="/administrator/*" element={<RedirectToAdministration />} />
        <Route path="/service-exception" element={<ServiceException />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </Box>
  );
};

export default CasRouter;
